<template>
    <div class="group-section">
         <v-container class="tab-header the-main-concept">
           <h1>{{$t('group.group')}}</h1>
         </v-container>
        <v-container grid-list-md text-xs-center class="group-main the-main-concept p-0">
            <v-layout class="group-inputs-sect">
              <v-flex class="members-groups-search-sect">
<!--              <div class="search-input-area">-->
<!--                <v-text-field-->
<!--                        solo-->
<!--                        flat-->
<!--                        class="the-group-filter"-->
<!--                        placeholder="Search"-->
<!--                        append-icon="icon-magnifying-glass"-->
<!--                ></v-text-field>-->
<!--              </div>-->
                <div class="ex-group-search search-people-sect">
                  <search-individual-components
                          class="groups-search"
                  />
                  <div class="mt-3 group-assignment">
                    {{$t('group.group_assignment')}}
                  </div>
                </div>

              </v-flex>
              <v-flex :class="groups.length === 0 && 'no-group-class'" md3 sm6 xs12 class="add-group-btn-sect">
                <h3 v-if="groups.length === 0" class="text-md-center no-group-found-msg">
                  {{$t('no_groups_found')}}
                </h3>
                <v-btn @click="addNewGroup" :ripple="false" class="add-groups-btn">
                  <v-icon>icon-plus-big</v-icon>
                </v-btn>
                <span> {{$t('group.add_new_group')}}</span>
              </v-flex>
            </v-layout>
            <v-layout row wrap class="g-card all-groups-sect">
             <v-flex :class="groups.length === 0 && 'no-group-class'" md3 sm6 xs12 class="add-group-btn-sect">
               <h3 v-if="groups.length === 0" class="text-md-center no-group-found-msg">
                 {{$t('no_groups_found')}}
               </h3>
               <v-btn @click="addNewGroup" :ripple="false" class="add-groups-btn">
                 <v-icon>icon-plus-big</v-icon>
               </v-btn>
               <span> {{$t('group.add_new_group')}}</span>
             </v-flex>
              <v-flex md3 sm6  v-for="group in groups" :key="group.id"  class="g-product-list-item">
                <v-card class="group-card-sect mr-0">
                  <div class="g-item-list" @click="openGroupPage(group.id)">
                    <div class ="g-card-img groupImg" v-if="group.image" >
                      <img  :src="`${ROOT_API}${group.image}` " alt="Group image">
                    </div>
                    <div class ="g-card-img group-no-Img" v-else >
                      <img  src="../../assets/images/group-2.svg" alt="Group image" />
                    </div>
                  </div>
                  <v-container fill-height class="group-name-sect">
                    <v-layout fill-height class="g-header">
                      <v-flex xs10 align-center justify-space-between d-flex>
                        <span class="headline"> {{ group.displayData.name }}</span>
                      </v-flex>
                      <v-toolbar-items class="justify-end w-15 group-dropdown-menu"  v-if="loggedUser.id === group.userId">
                        <v-menu open-on-click class="dropdown-section-menu" nudge-left="160px">
                          <v-flex slot="activator"
                                  class="d-flex justify-center align-center menu-drop-sect">
                                  <v-icon>icon-more-hover</v-icon>
                          </v-flex>
                          <v-list class="group-menu-list">
                            <v-list-tile class="list-item">
                              <v-list-tile-title @click="openEditGroupModal(group)" ><i class="icon-edit-profile"></i>{{ $t('group.edit_group') }}</v-list-tile-title>
                            </v-list-tile>
                            <v-list-tile  class="list-item">
                              <v-list-tile-title @click="openDeleteGroupModal(group)"><i class="icon-remove-565"></i>{{ $t('group.delete') }}</v-list-tile-title>
                            </v-list-tile>
                          </v-list>
                        </v-menu>
                      </v-toolbar-items>
                    </v-layout>
                  </v-container>
                  <v-card-title v-if="group.displayData.description " class="group-description-sect">
                    <div>
                      {{ group.displayData.description = group.displayData.description.length > 50 ? group.displayData.description = group.displayData.description.substring(0, 50) + '...' : group.displayData.description}}
                    </div>
                  </v-card-title>
                  <v-layout row wrap class="member-img-sect">
                    <v-list-tile-avatar v-if="group.Creator" class="test create">
                      <router-link v-if="group.Creator.image" :to="/accounts/ + group.userId">
                          <img :src="`${ROOT_API}${group.Creator.image}`" alt="Group image">
                      </router-link>
                      <i v-else class="material-icons">
                        account_circle
                      </i>
                    </v-list-tile-avatar>
                    <v-list-tile-avatar v-if="group.UserGroups.length > 0" class="test my-members d-flex">
                      <div v-for="(member,index) in group.UserGroups" :key="member.User.id" v-if="index < 4" class="img-parent-div">
                        <router-link v-if="member.User.image" :to="/accounts/ + member.User.id">
                          <img class="memberImg" :src="`${ROOT_API}${member.User.image}`" :alt="$t('avatar')">
                        </router-link>
                        <router-link v-else :to="/accounts/ + member.User.id">
                          <v-icon class="material-icons">
                            account_circle
                          </v-icon>
                        </router-link>
                      </div>
                    </v-list-tile-avatar>
                    <div v-if="group.UserGroups.length > 4" class="group-count">{{"+" + (group.UserGroups.length - 4)}}</div>
                    <div v-else-if="group.UserGroups.length < 1" class="no-user">
                      <span>
                         {{$t('group.no_group_member')}}
                      </span>
                    </div>
                  </v-layout>
                </v-card>
              </v-flex>
            </v-layout>
        </v-container>
      <!--Add modal-->
        <v-dialog v-model="dialog" max-width="550px" persistent>
            <v-card class="group-modal-sect">
              <v-btn
                      @click.native="closeModal"
                      class="cancel-modal-btn"
                      flat
                      :ripple="false"
              >
                <v-icon>icon-cancel</v-icon>
              </v-btn>
                <v-card-title class="card-headline-title">
                    <span class="headline">{{$t('group.add_new_group')}}</span>
                </v-card-title>
                <v-card-text class="modal-card-text">
                    <v-container grid-list-md>
                      <v-form ref="form" lazy-validation>
                        <v-layout wrap class="modal-input-sect">
                            <v-flex class="group-img-section">
                              <div class ="avatarImg" v-if="avatarImg">
                                <img :src="avatarImg" :alt="$t('avatar')" />
                                <div class="avatar-action">
                                  <i class="icon-cancel" @click="deleteGroupImgAdd"/>
                                  <v-btn @click="tiggerInputFile()" flat :ripple="false" class="group-img-edit-btn">
                                    <v-icon>icon-edit-profile</v-icon>
                                  </v-btn>
                                  <input class="edit-group-img d-none" type="file" ref="file" :multiple="false" :data-buttonText="$t('avatar')" v-on:change="onFileChange(groupData.image,$event)">
                                </div>
                              </div>
                              <div v-else class="modal-dashed-image">
                                <input class="add-group-img" type="file" ref="new-file" :multiple="false" :data-buttonText="$t('avatar')" v-on:change="onFileChange(groupData.image,$event)">
                                <span>{{$t('group.add_group_photo')}}</span>
                              </div>
                              <input v-if="show" class="add-group-img" type="file" ref="file" :multiple="false" :data-buttonText="$t('avatar')" v-on:change="onFileChange(groupData.image,$event)">
                            </v-flex>
                          <v-flex xs12 class="group-name-input">
                            <v-text-field
                                class="ex-input-group"
                                v-model="groupData.name"
                                :placeholder="$t('group.group_title')"
                                :rules="nameRules"
                                required>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 class="group-description-input">
                            <v-textarea
                                v-model="groupData.description"
                                :counter="80"
                                name="groupData.description"
                                :placeholder="$t('products.description')"
                                class="group-textarea ex-input-group"
                                height="138px"
                                no-resize
                            >
                            </v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions class="modal-card-action">
                    <v-btn
                            @click="createGroup"
                            class="create-modal-btn"
                            flat
                            :ripple="false"
                    >
                      {{$t('group.add')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
      <!--edit group modal-->
      <v-dialog v-model="dialogEdit" max-width="550px" persistent>
            <v-card class="group-edit-modal">
                <v-card-title class="headline-text">
                    <span>{{$t('group.edit_group')}}</span>
                  <v-btn @click.native="closeModal" flat :ripple="false" class="group-delete-x-btn">
                    <v-icon>icon-cancel</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text class="group-edit-text">
                    <v-container grid-list-md>
                      <v-form ref="form" v-model="valid" lazy-validation>
                        <v-layout wrap >
                            <v-flex class="img-main-sect">
                              <div class ="group-img-section" v-if="avatarImg">
                                <div class="group-img">
                                  <img :src="avatarImg" :alt="$t('avatar')" />
                                  <div class="avatar-action">
                                    <i class="icon-cancel" @click="deleteGroupImg"/>
                                    <v-btn @click="tiggerInputFile()" flat :ripple="false" class="group-img-edit-btn">
                                      <v-icon>icon-edit-profile</v-icon>
                                    </v-btn>
                                    <input class="edit-group-img d-none" type="file" ref="file" :multiple="false" :data-buttonText="$t('avatar')" v-on:change="onFileChange(groupData.image,$event)">
                                  </div>
                                </div>
                              </div>
                              <div v-else class="none-image-section">
                                <input class="add-group-img" type="file" ref="file" :multiple="false" :data-buttonText="$t('avatar')" v-on:change="onFileChange(groupData.image,$event)">
                                <span>{{$t('group.add_group_photo')}}</span>
                              </div>
                              <input v-if="show" class="add-group-img" type="file" ref="file" :multiple="false" :data-buttonText="$t('avatar')" v-on:change="onFileChange(groupData.image,$event)">
                            </v-flex>
                          <v-flex xs12 class="group-name-edit-sect">
                            <v-text-field
                                class="ex-input-group edit-name-input"
                                v-model="groupData.name"
                                :placeholder="$t('group.name')"
                                :rules="nameRules"
                                required>
                            </v-text-field>
                          </v-flex>
                          <v-flex xs12 class="group-description-edit-sect">
                            <v-textarea
                                v-model="groupData.description"
                                :counter="80"
                                name="groupData.description"
                                class="ex-input-group edit-description-area"
                                :placeholder="$t('products.description')"
                                no-resize
                            >
                            </v-textarea>
                          </v-flex>
                        </v-layout>
                      </v-form>
                    </v-container>
                </v-card-text>
                <v-card-actions class="edit-btn-sect">
                    <v-btn @click.native="closeModal" flat :ripple="false" class="group-edit-cancel-btn">{{$t('group.cancel')}}</v-btn>
                    <v-btn color="primary" @click="editGroup" flat :ripple="false" class="group-edit-btn">{{$t('group.edit')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog
            v-model="avatarImgCropSrc"
            width="500px"
            v-if="avatarImgCropSrc"
            persistent
        >
          <v-card class="cropper-style-sect">
            <v-card-text>
              <vue-cropper
                  class="resp-cropper-sect"
                  style="max-height: 500px"
                  ref="cropperAvatarImg"
                  :src="avatarImgCropSrc"
                  :alt="$t('products.image')"
                  dragMode="move"
                  :aspectRatio="3 / 2"
                  :autoCropArea="0"
                  :movable="false"
                  :rotatable="false"
                  :scalable="false"
                  :viewMode="1"
                  :zoomable="false"
              >
              </vue-cropper>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions class="cropper-btn-sect">
              <v-btn flat :ripple="false" @click="cancelCropAvatarImg" class="cancel-crop-btn">{{$t('products.cancel')}}</v-btn>
              <v-btn flat @click="cropAvatarImg" :ripple="false" class="accept-crop-btn">{{$t('products.crop_image')}}</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      <!--group delete modal-->
      <v-dialog v-model="deleteModal" max-width="550px">
        <v-card class="group-delete-modal">
          <v-card-title class="headline-text">
            <span>{{$t('group.delete_group')}}</span>
            <v-btn @click.native="closeModal" flat :ripple="false" class="group-delete-x-btn">
              <v-icon>icon-cancel</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="card-text">
            <v-container grid-list-md>
              <v-layout wrap>
                <v-flex>
                  <span>{{$t('group.delete_group_text')}}</span>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions class="delete-btn-sect">
            <v-btn @click.native="closeModal" flat :ripple="false" class="group-delete-cancel-btn">{{$t('group.cancel')}}</v-btn>
            <v-btn @click.native="deleteGroup" flat :ripple="false" class="group-delete-btn">{{$t('group.delete')}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>

</template>

<script>
import {mapState} from 'vuex'
import SearchIndividualComponents from '../profilePage/components/SearchIndividualUsers'
import VueCropper from 'vue-cropperjs'
import { EventBus } from '../../event-bus'

export default {
  name: 'MyGroups',
  components: {
    VueCropper: VueCropper,
    SearchIndividualComponents
  },
  data: () => ({
    groups: [],
    valid: true,
    show: false,
    dialogEdit: false,
    deleteModal: false,
    editModal: false,
    ROOT_API: process.env.ROOT_API,
    loading: false,
    validInvitationEmail: false,
    isLogged: true,
    signUpData: false,
    dialog: false,
    deleteGroupId: null,
    groupData: {
      id: '',
      name: '',
      description: '',
      image: []
    },
    currentGroup: {
      name: '',
      creatorName: '',
      members: []
    },
    avatarImg: '',
    avatarImgCropSrc: '',
    croppedAvatar: {},
    file: '',
    deleteItem: ''
  }),
  computed: {
    ...mapState({
      loggedUser: state => state.auth.userData
    }),
    nameRules () {
      return [v => (!!v && v.trim() !== '') || this.$t('group.group_name_required')
      ]
    }
  },
  watch: {
    dialog (val) {
      val || this.closeModal()
    }
  },
  methods: {
    tiggerInputFile () {
      this.$refs.file.click()
    },
    openGroupPage (item) {
      if (item) {
        this.$router.push('/profile/my-groups/' + item)
      }
    },
    openEditGroupModal (item) {
      if (item.Creator.id === this.loggedUser.id) {
        let group = Object.assign({}, item)
        this.dialogEdit = true
        this.groupData.id = group.id
        this.groupData.name = group.displayData.name
        this.groupData.description = group.displayData.description
        if (group.image) {
          this.avatarImg = this.ROOT_API + group.image
        } else {
          this.avatarImg = ''
        }
      } else {
        this.$toastr('error', this.$t('group.permission'), this.$t('error'))
      }
    },
    addNewGroup () {
      this.dialog = true
    },
    createGroup () {
      if (this.$refs.form.validate()) {
        this.dialog = false
        const formData = new FormData()
        formData.append('file', this.croppedAvatar['blob'])
        this.$store.dispatch('groups/add', {name: this.groupData.name, description: this.groupData.description, image: this.groupData.image, formData})
          .then(response => {
            this.cleanData()
            this.getGroups()
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        this.$toastr('error', this.$t('fill_required_fields'), this.$t('error'))
        return false
      }
    },
    editGroup () {
      if (this.$refs.form.validate()) {
        this.dialogEdit = false
        const formData = new FormData()
        formData.append('file', this.croppedAvatar['blob'])
        this.$store.dispatch('groups/edit', {groupData: this.groupData, formData})
          .then(response => {
            this.cleanData()
            this.getGroups()
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        this.$toastr('error', this.$t('fill_required_fields'), this.$t('error'))
        return false
      }
    },
    onFileChange (item, e) {
      let files = e.target.files || e.dataTransfer.files
      if (!files.length) {
        return
      }
      if (files[0].size > 1024 * 1024 * 3) {
        this.$toastr('error', this.$t('products.image_upload_max_size'), this.$t('error'))
        this.deleteRefsFileValue()
        return
      }
      this.file = files[0]

      const reader = new FileReader()
      reader.onload = (e) => {
        this.avatarImgCropSrc = e.target.result
      }
      reader.readAsDataURL(this.file)
    },
    cancelCropAvatarImg () {
      this.file = ''
      this.deleteRefsFileValue()
      this.$refs.cropperAvatarImg && this.$refs.cropperAvatarImg.destroy()
      this.avatarImgCropSrc = null
      this.croppedAvatar = {}
    },
    cropAvatarImg () {
      // get image data for post processing, e.g. upload or setting image src
      const croppedCanvas = this.$refs.cropperAvatarImg && this.$refs.cropperAvatarImg.getCroppedCanvas({
        width: 900,
        height: 600
      })
      if (croppedCanvas) {
        const dataURL = croppedCanvas.toDataURL()
        this.avatarImgCropSrc = null
        this.avatarImg = dataURL
        croppedCanvas.toBlob((blob) => {
          this.croppedAvatar['blob'] = blob
          this.groupData.image.push(blob)
        }, 'image/jpeg', 0.7)
      }
    },
    deleteRefsFileValue () {
      this.$refs.file.value = ''
      if (this.$refs['new-file']) {
        this.$refs['new-file'].value = ''
      }
    },
    getGroups () {
      this.$store.dispatch('groups/getAllGroups')
        .then(response => {
          this.groups = response.groups
        }).catch(err => {
          console.log(err)
        })
    },
    languageChanged () {
      this.getGroups()
    },
    openDeleteGroupModal (item) {
      this.deleteItem = item
      this.deleteModal = true
    },
    closeModal () {
      this.dialogEdit = false
      this.dialog = false
      this.deleteModal = false
      this.cleanData()
    },
    deleteGroup () {
      if (this.deleteItem) {
        if (this.deleteItem.Creator.id === this.loggedUser.id && this.deleteItem.id) {
          this.deleteModal = false
          this.$store.dispatch('groups/deleteGroup', this.deleteItem.id).then((res) => {
            if (res.status) {
              this.getGroups()
              this.$toastr(res.type, res.message, this.$t(res.type))
            }
          }).catch(console.error)
        } else {
          this.$toastr('error', this.$t('group.permission'), this.$t('error'))
        }
      }
    },
    cleanData () {
      this.croppedAvatar = {}
      this.avatarImg = ''
      this.groupData = {
        id: '',
        name: '',
        description: '',
        image: []
      }
    },
    deleteGroupImg () {
      this.groupData.image = []
      this.croppedAvatar = {}
      this.avatarImg = ''
      if (this.groupData.id) {
        this.$store.dispatch('groups/deleteGroupImg', this.groupData.id).then((res) => {
          if (res.status) {
            this.getGroups()
            this.$toastr(res.type, res.message, this.$t(res.type))
          }
        }).catch(console.error)
      }
    },
    deleteGroupImgAdd () {
      this.avatarImg = ''
    }
  },
  created () {
    EventBus.$on('language-changed', this.languageChanged)
    this.getGroups()
  }
}
</script>

<style scoped lang="scss">

  .text {
    overflow: hidden;
    text-overflow: fade;
    display: -webkit-box;
    -webkit-line-clamp: 4; /* number of lines to show */
    -webkit-box-orient: vertical;
  }
  @import "../../assets/sass/desktop/myGroups";
</style>



// WEBPACK FOOTER //
// src/components/profilePage/MyGroups.vue